var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoutRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_925_12680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.498 16.5039C19.298 16.5039 19.109 16.4259 18.968 16.2839C18.676 15.9919 18.676 15.5159 18.968 15.2229L21.438 12.7529H7.49805C7.08405 12.7529 6.74805 12.4169 6.74805 12.0029C6.74805 11.5889 7.08405 11.2529 7.49805 11.2529H21.437L18.967 8.78293C18.825 8.64193 18.747 8.45293 18.747 8.25293C18.747 8.05293 18.825 7.86393 18.967 7.72293C19.109 7.58193 19.297 7.50293 19.497 7.50293C19.697 7.50293 19.886 7.58093 20.027 7.72293L23.777 11.4729C23.812 11.5079 23.843 11.5459 23.871 11.5869C23.878 11.5969 23.886 11.6119 23.893 11.6249C23.91 11.6529 23.925 11.6819 23.938 11.7119C23.945 11.7279 23.954 11.7569 23.959 11.7729C23.967 11.7929 23.976 11.8239 23.982 11.8569C23.991 11.8999 23.997 11.9509 23.997 12.0029C23.997 12.0529 23.992 12.1029 23.982 12.1509C23.976 12.1809 23.967 12.2099 23.957 12.2389C23.953 12.2549 23.945 12.2769 23.936 12.2969C23.927 12.3199 23.911 12.3499 23.893 12.3799C23.892 12.3829 23.883 12.4009 23.872 12.4169C23.85 12.4489 23.83 12.4739 23.808 12.4979C23.807 12.5009 23.793 12.5179 23.777 12.5329L20.027 16.2829C19.886 16.4259 19.698 16.5039 19.498 16.5039Z",
    stroke: "none",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.09241 23.25C0.884411 23.189 -0.0555895 22.165 -0.000589489 20.966L-0.00158949 3C-0.0565895 1.828 0.874411 0.811 2.07441 0.751L14.3844 0.75C15.6124 0.81 16.5514 1.835 16.4974 3.034L16.4984 7.5C16.4984 7.914 16.1624 8.25 15.7484 8.25C15.3344 8.25 14.9984 7.914 14.9984 7.5V3C15.0164 2.597 14.7234 2.268 14.3464 2.249L2.11141 2.25C1.77041 2.268 1.48041 2.596 1.49741 2.966L1.49841 21C1.48041 21.403 1.77341 21.732 2.14941 21.751L14.3844 21.75C14.7254 21.732 15.0164 21.404 14.9994 21.034L14.9984 16.5C14.9984 16.086 15.3344 15.75 15.7484 15.75C16.1624 15.75 16.4984 16.086 16.4984 16.5V21C16.5524 22.173 15.6204 23.189 14.4214 23.249L2.11141 23.25C2.10541 23.25 2.09841 23.25 2.09241 23.25Z",
    stroke: "none",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_925_12680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutRegular);
export default __webpack_public_path__ + "static/media/logout-regular.74f5918883a38f02629f7043fc073456.svg";
export { ForwardRef as ReactComponent };